(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbHelpers", [], factory);
	else if(typeof exports === 'object')
		exports["sbHelpers"] = factory();
	else
		root["sbHelpers"] = factory();
})(window, function() {
return 